'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  event: {
    num_dates: 'une autre date |||| %{smart_count} autres dates',
    num_times: 'une autre heure |||| %{smart_count} autres heures',
    prices: {
      free: 'Gratuit',
      fixed: 'Payant',
      donation: 'Contribution volontaire'
    },
    show_counter: 'Consulté %{smart_count} fois',
    entities: {
      audiences: 'Publics',
      events: 'Évènements',
      regions: 'Quartiers',
      types: 'Types',
      tags: 'Mots-clés',
      venues: 'Lieux',
      organizations: 'Organisations'
    },
    entities_all: {
      audiences: 'Tous les publics',
      events: 'Tous les évènements',
      regions: 'Tous les quartiers',
      types: 'Tous les types',
      tags: 'Tous les mots-clés',
      venues: 'Tous les lieux',
      organizations: 'Toutes les organisations'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/event.js
// module id = 1163
// module chunks = 0